import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '@ant-design/icons';
import { Button } from 'antd';
import { allFiltersSelector, liveModeSelector } from '@store/metricLens/base/selectors';
import barIcon from '@src/icons/charts/bar.svg';
import lineIcon from '@src/icons/charts/line.svg';
import { track } from '@utils';
import { CLICK_ML_CHART_MODE_CHANGE } from '@src/utils/sensor/track';
import { StyledRowHeader } from './styled';
import useTimeseries, { useTsRow } from './hooks/useTimeseries';
import ExportTsRow from './ExportTsRow';

const RowHeader = (props) => {
  const { text, rowData } = props;
  const dispatch = useDispatch();
  const liveMode = useSelector(liveModeSelector);
  const allFilters = useSelector(allFiltersSelector);
  const [active, setActive] = useState('bar');
  const [disableLine, setDisableLine] = useState(false);

  const [tsMode, setTsMode] = useTsRow(rowData.id);

  const { data: timeseriesData } = useTimeseries({ row: rowData, enabled: !!tsMode });

  // TODO: is this required now that we don't persist?
  useEffect(() => {
    if (tsMode) {
      setActive('line');
    } else {
      setActive('bar');
    }
  }, [tsMode, rowData]);

  useEffect(() => {
    if (liveMode) {
      setDisableLine(true);
      if (tsMode) {
        setTsMode(false);
      }
    } else {
      const granularities = [];
      allFilters.forEach((filter) => {
        granularities.push(filter.granularity);
      });
      const filteredGranularity = new Set(granularities.filter(Boolean));
      if (filteredGranularity.size > 1) {
        setDisableLine(true);
        setTsMode(false);
      } else {
        setDisableLine(false);
      }
    }
  }, [liveMode, allFilters, dispatch]);

  const handleTimeseriesChart = () => {
    setTsMode(true);
    track({
      event: CLICK_ML_CHART_MODE_CHANGE,
      data: {
        dimension: rowData,
      },
    });
  };

  const handleBarChart = () => {
    setTsMode(false);
  };

  return (
    <StyledRowHeader>
      <div className="row-header-text" title={text}>
        {text}
      </div>
      <div className="row-header-chart-switch">
        <Button
          disabled={disableLine}
          type="link"
          size="small"
          className={active === 'line' ? 'active line' : 'line'}
          onClick={handleTimeseriesChart}
        >
          <Icon component={lineIcon} />
        </Button>
        <Button
          type="link"
          size="small"
          className={active === 'bar' ? 'active bar' : 'bar'}
          onClick={handleBarChart}
        >
          <Icon component={barIcon} />
        </Button>
      </div>
      {timeseriesData.map((data, index) => (
        <ExportTsRow
          data={data}
          rowData={rowData}
          filterIndex={index}
          key={`${rowData.id}-${index}`}
        />
      ))}
    </StyledRowHeader>
  );
};

export default memo(RowHeader);
